import React from "react";
import { Routes, Route, useNavigate, useLocation, useParams } from "react-router-dom";
import { UsersLoadingDialog } from "./users-loading-dialog/UsersLoadingDialog";
import { UserDeleteDialog } from "./user-delete-dialog/UserDeleteDialog";
import { UsersDeleteDialog } from "./users-delete-dialog/UsersDeleteDialog";
import { UsersFetchDialog } from "./users-fetch-dialog/UsersFetchDialog";
import { UsersUpdateStatusDialog } from "./users-update-status-dialog/UsersUpdateStatusDialog";
import { UsersCard } from "./UsersCard";
import { UsersUIProvider } from "./UsersUIContext";

function UsersDeleteDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <UsersDeleteDialog show={location.pathname === "/user/deleteUsers"} onHide={() => navigate("/user")} />;
}
function UserDeleteDialogRoute() {
  const navigate = useNavigate();
  const { id } = useParams();
  return <UserDeleteDialog show id={id} onHide={() => navigate("/user")} />;
}
function UsersFetchDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <UsersFetchDialog show={location.pathname === "/user/fetch"} onHide={() => navigate("/user")} />;
}
function UsersUpdateStatusDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <UsersUpdateStatusDialog show={location.pathname === "/user/updateStatus"} onHide={() => navigate("/user")} />;
}

export function UsersPage() {
  const navigate = useNavigate();
  const usersUIEvents = {
    newUserButtonClick: () => navigate("/user/new"),
    openEditUserPage: (id) => navigate(`/user/${id}/edit`),
    openDeleteUserDialog: (id) => navigate(`/user/${id}/delete`),
    openDeleteUsersDialog: () => navigate("/user/deleteUsers"),
    openFetchUsersDialog: () => navigate("/user/fetch"),
    openUpdateUsersStatusDialog: () => navigate("/user/updateStatus"),
  };

  return (
    <UsersUIProvider usersUIEvents={usersUIEvents}>
      <UsersLoadingDialog />
      <Routes>
        <Route path="deleteUsers" element={<UsersDeleteDialogRoute />} />
        <Route path=":id/delete" element={<UserDeleteDialogRoute />} />
        <Route path="fetch" element={<UsersFetchDialogRoute />} />
        <Route path="updateStatus" element={<UsersUpdateStatusDialogRoute />} />
      </Routes>
      <UsersCard />
    </UsersUIProvider>
  );
}
